import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import Verified from '../../Assets/svg/Verified';

export default function TransitionAlerts(props) {

  return (
    <Box className={'alert'} sx={{position:'absolute', width: '100%' }}>
      <Collapse in={props.isAlert}>
      <Alert className='set-sub-title' icon={<Verified fontSize="inherit" />} severity="success">
    {props.message}
    </Alert>
      </Collapse>
    </Box>
  );
}
